<div class="btn-group" dropdown>
  <button
    nkButton
    color="primary"
    dropdownToggle
    type="button"
    aria-controls="dropdown-watchlist"
    class="dropdown-toggle"
    id="watchlistDropdownMenu">
    {{ label | translate }}
  </button>
  <ul
    *dropdownMenu
    class="dropdown-menu w-100"
    aria-labelledby="dropdown-watchlist-button"
    role="menu"
    style="max-height: 280px; max-width: 100%; overflow-y: auto; overflow-x: hidden">
    @if (watchlistOptions$ | async; as watchlistOptions) {
      @for (watchlist of watchlistOptions; track watchlist.uuid) {
        <li>
          <button class="dropdown-item" role="menuitem" (click)="onAddToWatchlist(watchlist)">
            <strong>{{ watchlist.name }}</strong>
          </button>
        </li>
      }
      @if (!watchlistOptions?.length) {
        <li>
          @if (roleDim$ | async; as roleDim) {
            <span class="dropdown-item small">
              {{
                roleDim.flags.superuser
                  ? 'watchlists.add_to_watchlist_dropdown.no_data_superuser'
                  : ('watchlists.add_to_watchlist_dropdown.no_data' | translate)
              }}
            </span>
          }
        </li>
      }
      @if (!hideCreateLink) {
        <li>
          <button class="dropdown-item underline" (click)="onCreateWatchlist()" id="create-new-watchlist-item">
            {{ 'watchlists.add_to_watchlist_dropdown.create_new_watchlist' | translate }}
          </button>
        </li>
      }
    } @else {
      <li>
        <span class="p-2 d-inline-block">
          <nk-spinner display="inline"></nk-spinner>
        </span>
      </li>
    }
  </ul>
</div>
